"use client";
function e(t) {
  return t;
}
export {
  e as i
};
